// Keep up to date with Dash Slug in metaserver:
// metaserver/static/js/dash_bridge/hooks/useRouteToDash.ts
export enum RouteToSlug {
  HOME = "home",
  WRITE = "write",
  WRITE_WITH_TEMPLATE = "write_with_template",
  DRAFT = "draft",
}

export const getDeepLinkPath = (
  slug: RouteToSlug,
  params?: Record<string, string>,
) => {
  const path = `/route_to/${slug}`;
  const searchParams = new URLSearchParams(params).toString();
  return `${path}?${searchParams}`;
};

export const getFallbackDeepLinkUrl = (
  slug: RouteToSlug,
  params?: Record<string, string>,
) => {
  // We will ensure authentication here by redirecting to deep link after login redirect.
  const redirectPathEncoded = encodeURIComponent(getDeepLinkPath(slug, params));
  return `${window.location.origin}/login?redirectToPathEncoded=${redirectPathEncoded}`;
};
